<div id="root">
    <div *ngIf="isWelcomePage">
        <router-outlet></router-outlet>
        <privacy-footer-welcome  class="ui bottom fixed menu privacy-container"></privacy-footer-welcome>
    </div>
    <div *ngIf="!isWelcomePage">
        <privacy-footer  class="ui bottom fixed menu privacy-container"></privacy-footer>
        <div *ngIf="displayBar" class="ui top fixed menu" id="fixed-menu">
            <top-garage-navbar *ngIf="isGarage" class="full-width" (sidebarButtonClicked)="sidebarButtonClicked()"></top-garage-navbar>
            <top-trips-navbar *ngIf="isTrips" class="full-width" (sidebarButtonClicked)="sidebarButtonClicked()"></top-trips-navbar>
            <top-admin-navbar *ngIf="isAdmin" class="full-width" (sidebarButtonClicked)="sidebarButtonClicked()"></top-admin-navbar>
        </div>
        <sui-sidebar-container class="ui bottom attached segment">
            <sui-sidebar class="inverted vertical" #sidebar>
                <a class="item" (click)="navigationService.Navigate('/index'); sidebar.close();">Accueil</a>

                <a *ngIf="isGarage" class="item" (click)="navigationService.Navigate('/garage/home'); sidebar.close();">Votre garage</a>
                <a *ngIf="isGarage" class="item" (click)="navigationService.Navigate('/garage/car'); sidebar.close();">Véhicules neufs</a>
                <a *ngIf="isGarage" class="item" (click)="navigationService.Navigate('/garage/occasions'); sidebar.close();">Occasions</a>
                <a *ngIf="isGarage" class="item" (click)="navigationService.Navigate('/garage/leasing'); sidebar.close();">Locations</a>

                <a *ngIf="isTrips" class="item" (click)="navigationService.Navigate('/trips/home'); sidebar.close();">Voyages</a>

                <a *ngIf="isAdmin" class="item" (click)="navigationService.Navigate('/admin/occasions'); sidebar.close();">Occasions</a>
                <a *ngIf="isAdmin" class="item" (click)="navigationService.Navigate('/admin/leasing'); sidebar.close();">Van</a>
                <a *ngIf="isAdmin" class="item" (click)="navigationService.Navigate('/admin/reservations'); sidebar.close();">Réservations</a>
                <a *ngIf="isAdmin" class="item" (click)="navigationService.Navigate('/admin/webmaster'); sidebar.close();">Webmaster</a>
            </sui-sidebar>

            <sui-sidebar-sibling [isDimmedWhenVisible]="true">
                <header-garage-navbar *ngIf="isGarage" (sidebarButtonClicked)="sidebarButtonClicked()"></header-garage-navbar>
                <header-admin-navbar *ngIf="isAdmin" (sidebarButtonClicked)="sidebarButtonClicked()"></header-admin-navbar>
                <header-trips-navbar *ngIf="isTrips" (sidebarButtonClicked)="sidebarButtonClicked()"></header-trips-navbar>
                <router-outlet></router-outlet>
            </sui-sidebar-sibling>
        </sui-sidebar-container>
        <footer></footer>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/app.component.html